import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import MyFileAdmin from './MyFileAdmin';
import SleeveFileAdmin from './SleeveFileAdmin';

const Files = () => {
  const [activeTab, setActiveTab] = useState("myfile"); // Default: "myfile"

  return (
    <Tabs
      activeKey={activeTab}
      onSelect={(k) => setActiveTab(k)}
      className="gap-3 summary-tab border-0"
    >
      <Tab eventKey="myfile" title="MyFile">
        <MyFileAdmin type="myfile" />
      </Tab>
      <Tab eventKey="sleevefile" title="SleeveFile">
        <SleeveFileAdmin type="sleevefile" />
      </Tab>
    </Tabs>
  );
};

export default Files;
